export const CURRENCY = '₦'